export const _getGroupMembers = (state, action) => action.payload;

export const _setAddedGroupMembers = (state, action) => {
  state.addedGroupMembers = [...state.addedGroupMembers, action.payload];
};

export const _setRemovedGroupMembers = (state, action) => {
  state.removedGroupMembers = [...state.removedGroupMembers, action.payload];
};
